/* eslint-disable no-console, no-case-declarations, no-unused-vars */
import * as services from "@/services/api/common-data";

export function action(/* context */) {}

export async function getAllMasterData(context) {
  await getAllFilters(context);
  await getFaculties(context);
  await getDepartments(context);
  await getPrefixes(context);
  await getAssessments(context);
  await getSubjectGroups(context);
  await getSubjects(context);
}

export async function getAllFilters(context) {
  await getDegrees(context);
  await getProjects(context);
  await getCurriculums(context);
}

export async function getDegrees(context) {
  const data = await services.getDegrees();
  context.commit('storeDegrees', data);
}

export async function getProjects(context) {
  const data = await services.getProjects();
  context.commit('storeProjects', data);
}

export async function getFaculties(context) {
  const data = await services.getFaculties();
  context.commit('storeFaculties', data);
}

export async function getDepartments(context) {
  const data = await services.getDepartments();
  context.commit('storeDepartments', data);
}

export async function getPrefixes(context) {
  const data = await services.getPrefixes();
  context.commit('storePrefixes', data);
}

export async function getCurriculums(context) {
  const data = await services.getCurriculums();
  context.commit('storeCurriculums', data);
}

export async function getAssessments(context) {
  const data = await services.getAssessments();
  context.commit('storeAssessments', data);
}

export async function getSubjectGroups(context) {
  const data = await services.getSubjectGroups();
  context.commit('storeSubjectGroups', data);
}

export async function getSubjects(context) {
  const data = await services.getSubjects();
  context.commit('storeSubjects', data);
}
